import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22./fonts/Denton-Regular.woff2%22,%22variable%22:%22--font-denton%22,%22weight%22:%22400%22,%22style%22:%22normal%22}],%22variableName%22:%22Denton%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Denton', 'Denton Fallback'",
        fontWeight: 400,
fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
